import React, { FC, forwardRef } from "react"

import { Box, Group, Text, SelectItem, Space } from "@mantine/core"
import { FlagProps } from "mantine-flagpack"
import { useLanguage } from "../../../contexts/language-context"

export type LanguageEntry = {
    value: string
    label: string
    flag: FC<FlagProps> | null
    disabled?: boolean
}

type LanguageSelectItemProps = SelectItem & LanguageEntry

const LanguageSelectItem = forwardRef<HTMLDivElement, LanguageSelectItemProps>(
    ({ _value, label, Flag, disabled, ...props }, ref) => {
        const { L } = useLanguage()

        return (
            <Box ref={ref} {...props}>
                <Group noWrap>
                    {Flag ? <Flag w={20} radius="xs" /> : <Space w={20} />}
                    <Box>
                        <Text>{label}</Text>
                        {disabled && <Text size="xs">{L("Not supported at this time")}</Text>}
                    </Box>
                </Group>
            </Box>
        )
    },
)

export default LanguageSelectItem
